import * as React from 'react';
import { useEffect, useState, useRef } from "react";
import IconFontAwesome from "../../js/components/iconFontAwesome.tsx";
import useClickAway from "../../js/helpers/useClickAway.ts";
import type { MenuData } from "../../js/data/menuData.ts";
import useWindowScrollRaf from "../../js/helpers/useWindowScrollRaf.ts";
import Logo from "./logo.tsx";
import MenuItem, { filterMenuItemsByParent } from "./menuItem.tsx";
import clsx from 'clsx';

type Props = Readonly<{
	menu: MenuData,
	pathname: string,
}>

function Header({menu, pathname, ...otherProps}: Props) {
	const refHeader = useRef<HTMLHeadingElement>(null);
	const refMobileMenu = useRef<HTMLDivElement>(null);
	const [opened, setOpened] = useState<boolean>(false);

	const { x, y } = useWindowScrollRaf();
	const [isSticky, setIsSticky] = useState<boolean>(false);

	if (isSticky === false && y > 10) {
		setIsSticky(true);
	}
	if (isSticky === true && y == 0) {
		setIsSticky(false);
	}

	useClickAway(refMobileMenu, () => setOpened(false));

	useEffect(() => {
		setOpened(false);
	}, [pathname]);

	let logo = <><Logo textWhite={true} className={clsx("mx-0 my-2 max-w-[230px] transition-all", isSticky ? 'max-h-[44px]' : 'max-h-[56px]')}/></>;

	if (pathname === '/') {
		logo = <span className="inline-block">{logo}</span>;
	} else {
		logo = <a href="/" className="inline-block">{logo}</a>;
	}

	const rootMenuItems = filterMenuItemsByParent(menu, null);

	return (<>
		{/*<Dump {...menu}/>*/}
		{/*<div className="fixed top-0 left-0 z-50">*/}
		{/*	<Dump value={y}/>*/}
		{/*</div>*/}

		<div
			id="headerWrapper"
			className={clsx(
				"-top-[1px] bg backdrop-blur-md sticky z-10",
				isSticky ? "bg-blackAlmost/75" : 'bg-blackAlmost'
			)}
			{...otherProps}
			ref={refHeader}
		>
			<header className={clsx(
				"max-w-screen-2xl mx-auto text-center px-8 md:px-10 xl:px-20 transition-all ease-mine duration-500",
				isSticky ? "py-0" : 'py-0'
			)}>
				<div className={clsx(
					"flex flex-wrap items-center justify-between gap-x-4",
					isSticky ? "" : ""
				)}>
					{logo}

					<div className={clsx(
						"hidden lg:flex items-center justify-between",
						isSticky ? "" : ""
					)}>
						<menu className="mainMenu">
							{rootMenuItems?.map((item, index) => {
								return <MenuItem
									menu={menu}
									item={item}
									key={'item' + index}
									pathname={pathname}
									className={clsx(isSticky && 'isSticky')}
									index={index}
									siblingsCount={rootMenuItems.length - 1}
								/>;
							})}
						</menu>
					</div>

					<div className={clsx("hidden xl:inline-block", isSticky && "")}>
						<div className="tracking-widest text-primary-500 text-sm hidden lg:block mr-6 text-right">
							<a href="tel:+48505102109" className="no-underline hover:underline">
								<IconFontAwesome icon="icon-phone" className="mr-1.5 text-lg"/><b>+48 505 102 109 </b>
							</a>
						</div>
					</div>

					<a href="#mobileMenu"
					   className={clsx("iconHamburger block lg:hidden", opened && "iconHamburgerOpened")}
					   aria-label="Menu"
					   title="Menu"
					   onClick={() => setOpened((opened) => {
						   return !opened;
					   })}
					>
						<span/>
						<span/>
						<span/>
					</a>
				</div>
			</header>
		</div>

		<div className={clsx(
			"fixed top-0 right-0 z-80 h-full w-full transition-all duration-300",
			opened ? 'bg-black/50 visible backdrop-blur-sm' : 'backdrop-blur-none bg-secondary-300/0 invisible'
		)}/>

		<div id="mobileMenu" className={clsx(
			"fixed top-0 right-0 z-90 h-full w-full overflow-y-auto overscroll-y-none transition duration-500",
			opened ? 'translate-x-0' : 'translate-x-full'
		)}>
			<div className="float-right relative min-h-full w-[80%] bg-blackAlmost shadow-xl" ref={refMobileMenu}>
				<a
					href="#x"
					className="iconOpenClose iconOpened absolute top-7 right-8 sm:right-12"
					onClick={(event) => {
						event.preventDefault();
						setOpened(false);
					}}
					title="X"
				/>
				{/*<div className="pb-4 mb-8 border-b border-white">*/}
				{/*	<div className="inline-block">*/}
				{/*		<div className="logo small"/>*/}
				{/*	</div>*/}
				{/*</div>*/}

				<menu className="mobileMenu">
					{rootMenuItems?.map((item, index) => {
						return <MenuItem
							menu={menu}
							item={item}
							key={'item' + index}
							pathname={pathname}
							index={index}
							siblingsCount={rootMenuItems.length - 1}
						/>;
					})}
				</menu>
			</div>
		</div>
	</>);
}

export default Header;
